import angular from "angular";
import { DISCHARGE_ALERT_SERVICE, DischargeAlertService } from "./discharge-alert.service";

const DISCHARGE_ALERT_MODULE = "dischargeAlertModule";

angular.module(DISCHARGE_ALERT_MODULE, [])
    .service(DISCHARGE_ALERT_SERVICE, DischargeAlertService);

export { DISCHARGE_ALERT_MODULE, DISCHARGE_ALERT_SERVICE };
